var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelsummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V30C0 32.2091 1.79086 34 4 34H23C23.3763 34 23.7404 33.948 24.0857 33.8509C21.6473 32.3089 20 29.3709 20 26H3V24H20.1982C20.5036 22.4863 21.148 21.1174 22.0371 20H3V18H23V18.974C24.1244 17.9599 25.4975 17.2804 27 17.0696V4C27 1.79086 25.2091 0 23 0H4ZM3 8H23V6H3V8ZM23 14H3V12H23V14Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 33C32.866 33 36 29.866 36 26C36 22.134 32.866 19 29 19C25.134 19 22 22.134 22 26C22 29.866 25.134 33 29 33ZM33.7399 24.8139C34.1895 24.4053 34.2226 23.7096 33.8139 23.2601C33.4053 22.8105 32.7096 22.7774 32.2601 23.1861L27.4544 27.5548L25.6872 26.141C25.2128 25.7615 24.5206 25.8384 24.141 26.3128C23.7615 26.7872 23.8384 27.4794 24.3128 27.859L26.1467 29.326C26.9526 29.9708 28.1075 29.9343 28.8712 29.2401L33.7399 24.8139Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotelsummary);
export default __webpack_public_path__ + "static/media/Hotel summary.d0cb32e393e0afadce7945538a577f65.svg";
export { ForwardRef as ReactComponent };